// Announcement-banner backdrop: the Pine59 green "grid dark" data-texture art
// (public/art/topo-grid-dark.webp), shown boldly with a scrim that dims it
// behind the (centre/right) text and keeps it visible at the edges/top/bottom.
//
// The art is a WebP with 800/1200/1600px rungs (13/26/42 KiB); which one a
// phone picks depends on its DPR. It used to be a 2.8 MB PNG, which is what
// pushed mobile LCP past 20 s in Lighthouse. It sits under a scrim at 85 % opacity, so the lossy encode is
// invisible. The banner is the first thing on the page and on phones it is
// the LCP element, so it is fetched at high priority (React 19 also turns
// that into a <link rel="preload"> in the SSR head).

// Shared so the blog post's hero can reuse the same art.
export const BANNER_ART = "/art/topo-grid-dark.webp"

// `lazy` is for a backdrop far below the fold (the blog banner card's
// fallback): it drops the high fetch priority, so React doesn't preload a
// 1600px image for a card nobody sees on load.
export function ForestBackdrop({ lazy = false }: { lazy?: boolean }) {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      <img
        src={BANNER_ART}
        srcSet="/art/topo-grid-dark-800.webp 800w, /art/topo-grid-dark-1200.webp 1200w, /art/topo-grid-dark.webp 1600w"
        // object-cover: on phones the 3:2 art is ~1.5x the viewport wide
        sizes="(max-width: 640px) 150vw, 100vw"
        alt=""
        width={1600}
        height={1067}
        {...(lazy ? { loading: "lazy" as const } : { fetchPriority: "high" as const })}
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ opacity: 0.85, objectPosition: "center" }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(72% 130% at 57% 45%, rgba(0,41,15,0.92) 0%, rgba(0,41,15,0.5) 48%, rgba(0,41,15,0) 86%)",
        }}
      />
    </div>
  )
}
